<template>
  <el-container class="main_container">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="topics-title">
        <p>China-ASEAN Info</p>
      </div>
      <div class="DataModule full_height">
        <div
          class="mod-demo"
          ref="homePage"
        >
          <el-row
            :gutter="2"
            style="height:90%;"
          >
            <el-col
              :span="6"
              style="height:100%;"
            >
              <div class="container2">
                <!-- Revised on 2022-03-05 -->
                <div
                  class="box"
                  style="height:100%; padding:0;background-color:#fff;"
                >
                  <!-- <graph-view></graph-view> -->
                  <el-collapse
                    v-model="activeName"
                    accordion
                    @change="handleChange"
                    style="overflow-y: scroll;height: 100%;"
                  >
                    <!-- Revised on 2022-03-05 -->
                    <el-collapse-item
                      v-for="(item,index) in countries"
                      :name="item.name"
                      class="collaps"
                    >
                      <template slot="title">
                        <div style="width:100%; margin:0px; padding: 0;">
                          <el-image
                            class="icon-image"
                            :src="item.img"
                            fit="fit"
                            @click.stop=""
                          />
                          <span class="icon-span">{{item.name}}</span>
                          <span @click.stop="onChangeCountry(item)" style="padding: 0px 10px;float: right;color: #459bef;"> More>></span>
                        </div>
                      </template>
                      <el-table
                        :data="item.data"
                        border
                        prop="name"
                        :show-header="false"
                        style="width: 100%; font-size: 10px; margin:5px"
                        :row-style="{height:'30px'}"
                      >
                        <el-table-column
                          prop="name"
                          label='lable'
                          width="110"
                        />
                        <el-table-column
                          prop="val"
                          label="value"
                        />
                      </el-table>
                    </el-collapse-item>

                  </el-collapse>
                </div>
              </div>
            </el-col>
            <el-col
              :span="18"
              style="height:100%;"
            >
              <el-row
                :gutter="2"
                style="height:49%; margin-bottom: 1%;"
              >
                <el-col
                  :span="24"
                  style="height:100%;"
                >
                  <div
                    class="box"
                    style="width:100%;height:100%;"
                  >
                    <on-demand
                      :isOk="isOk"
                      :country="country"
                    ></on-demand>
                  </div>
                </el-col>
              </el-row>
              <el-row
                :gutter="2"
                style="height:49%; margin-bottom: 1%;"
              >
                <el-col
                  :span="24"
                  style="height:100%;"
                >
                  <div style="width:100%;height:100%;float: left;">
                    <div
                      class="box"
                      style="width:100%;height:100%;"
                    >
                      <forexView :isOk="isOk"></forexView>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-main>
  </el-container>

</template>

<script>
import graphView from './components/dm/graphView'
import forexView from './components/dm/forexView'
import interestView from './components/dm/interestView'
import financialView from './components/dm/financialView'
import OnDemand from './components/dm/OnDemand'
import { getDataMap } from "common/js/http/v3Api"
export default {
  data() {
    return {
      activeName: 'Brunei',
      countries: [
        // {
        //   id: 'China', name: 'China', countryCode: 'DM_CHN_MAIN', img: '/db/static/images/country/China.png',
        //   data: []
        // },
        {
          id: 'Brunei', name: 'Brunei', countryCode: 'DM_BRU_MAIN', img: '/db/static/images/country/Brunei.png',
          data: []
        },
        {
          id: 'Cambodia', name: 'Cambodia', countryCode: 'DM_KHM_MAIN', img: '/db/static/images/country/Cambodia.png',
          data: []
        },
        {
          id: 'Indonesia', name: 'Indonesia', countryCode: 'DM_IDN_MAIN', img: '/db/static/images/country/Indonesia.png',
          data: []
        },
        {
          id: 'Laos', name: 'Laos', countryCode: 'DM_LA_MAIN', img: '/db/static/images/country/Laos.png',
          data: []
        },
        {
          id: 'Malaysia', name: 'Malaysia', countryCode: 'DM_MAL_MAIN', img: '/db/static/images/country/Malaysia.png',
          data: []
        },
        {
          id: 'Myanmar', name: 'Myanmar', countryCode: 'DM_MMR_MAIN', img: '/db/static/images/country/Myanmar.png',
          data: []
        },
        {
          id: 'Philippines', name: 'Philippines', countryCode: 'DM_PHL_MAIN', img: '/db/static/images/country/Phillipine.png',
          data: []
        },
        {
          id: 'Singapore', name: 'Singapore', countryCode: 'DM_SG_MAIN', img: '/db/static/images/country/Singapore.png',
          data: []
        },
        {
          id: 'Thailand', name: 'Thailand', countryCode: 'DM_TH_MAIN', img: '/db/static/images/country/Thailand.png',
          data: []
        },
        {
          id: 'Vietnam', name: 'Vietnam', countryCode: 'DM_VNM_MAIN', img: '/db/static/images/country/Vietnam.png',
          data: []
        },
      ],
      isMobilePhone: false,
      clientHeight: '',
      isOk: true,
      country: { countryCode: '99' },
      setToken: null
    }
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  },

  mounted() {
    this.initHeight()
    this.getDataMap("Brunei")
  },
  activated() {
  },
  components: {
    graphView,
    forexView,
    interestView,
    financialView,
    OnDemand
  },
  methods: {
    changeFixed(clientHeight) {
      // 动态修改样式
      this.$refs.homePage.style.height = clientHeight + 'px'
    },
    initHeight() {  // 获取高度
      // 获取浏览器可视区域高度
      /* Revised on 2022-03-05 */
      this.clientHeight = document.body.clientHeight - 30
      window.onresize = () => {  // 当窗口或框架发生改变时触发
        this.clientHeight = document.body.clientHeight - 30
      }
      /* Revised on 2022-03-05 */
    },
    handleChange(val) {
      this.getDataMap(val)
    },
    onChangeCountry(item) { 
      this.$router.push({ name: 'ChinaASEANInfoCountry', params: item })
    },
    async getDataMap(countryId) {
      if (countryId === '')  return;
        const { data } = await getDataMap({
          countryId: countryId
        }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '078EACCDFD987897A4395700D662C8EB' })
        this.countries.forEach((obj) => {
          if (obj.id == data.result.country) {
            obj.data = data.result.infoList
          }
        })
        this.dataListLoading = false
    },
  }
}
</script>

<style>
 .el-collapse-item__header .el-collapse-item__arrow {
  display: none;
}
</style>
<style scoped>
.topics-title {
  font-size: 16px;
  font-weight: bolder;
  color: #515a6e;
  padding: 0px 0 0 3px;
  margin: -5px 0 -4px 0;
  height: 24px;
}
.topics-title p {
    height: 16px;
    line-height: 16px;
    padding: 0 0 0 12px;
    border-left: 2px solid #007bff;
}

.icon-image {
  margin-left: 5px;
  margin-right: 5px;
  width: 30px;
  height: 20px;
}

.icon-span {
  font-size: 13px;
  vertical-align: center;
}

body {
  overflow: hidden;
}
.mod-demo {
  min-height: 597px;
  width: 100%;
  height: 100%;
  background-color: #ebecee;
}
.mod-demo .box {
  border: #cfd1d8 1px solid;
  margin-left: 3px;
  margin-top: 3px;
}
.container2 {
  position: relative;
  width: 100%;
  height: 100%;
}
.left2 {
  height: 50%;
  width: 100%;
}
.right2 {
  position: absolute;
  width: 100%;
  top: 50%;
  bottom: 0;
  left: 0;
}
@media screen and (max-width: 1363px) {
  .DataModule {
    padding-right: 0;
  }
  body {
    overflow: scroll;
  }
}
::-webkit-scrollbar,
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-track-piece {
  -webkit-border-radius: 5px;
}
::-webkit-scrollbar-thumb:vertical,
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: #babdc6 !important;
  -webkit-border-radius: 5px;
}
::-webkit-scrollbar-thumb:horizontal,
::-webkit-scrollbar-thumb:horizontal {
  width: 3px;
  background-color: #babdc6 !important;
  -webkit-border-radius: 5px;
}
::-webkit-scrollbar-corner,
::-webkit-scrollbar-corner {
  background-color: #ebecee !important;
}
</style>
